import { render, staticRenderFns } from "./SSnackbar.vue?vue&type=template&id=f1ebf1aa&scoped=true&"
import script from "./SSnackbar.vue?vue&type=script&lang=js&"
export * from "./SSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./SSnackbar.vue?vue&type=style&index=0&id=f1ebf1aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ebf1aa",
  null
  
)

export default component.exports